import { useTranslation } from 'react-i18next';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { FinancialPlanChipSelector } from 'components/BusinessToolForm/Sections/FinancialPlan/components/FinancialPlanChipSelector';
import {
  financialPlanOptionsToComponentMap,
  IFinancialPerformanceValuesType,
} from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/utils/form';
import { useGetFinancialPerfomanceOptions } from 'components/BusinessToolForm/Sections/FinancialPlan/hooks/useGetFinancialPerfomanceOptions';
import {
  ActiveTabContextProvider,
  useTabChangeContext,
} from 'components/BusinessToolForm/Sections/FinancialPlan/hooks/useTabChangeContext';

export const FinancialPerformanceContent: React.FC = () => {
  const { t } = useTranslation();

  const { activeTab, onTabChange } = useTabChangeContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN,
    BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.FINANCIAL_PERFORMANCE,
  );

  const options = useGetFinancialPerfomanceOptions();

  const tabsForInvestors = options.slice(0, 2);

  const Component = financialPlanOptionsToComponentMap[activeTab.value as IFinancialPerformanceValuesType];

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('financialPlan.title')}
          badgeText={t('financialPlan.financialPerformance.title')}
        />
      </FormSectionCard>

      <FinancialPlanChipSelector options={tabsForInvestors} selected={activeTab} onChange={onTabChange} />

      <Component />
    </>
  );
};

export const FinancialPerformance: React.FC = () => {
  const options = useGetFinancialPerfomanceOptions();
  return (
    <ActiveTabContextProvider initialValue={options[0]}>
      <FinancialPerformanceContent />
    </ActiveTabContextProvider>
  );
};
